module.exports = __webpack_public_path__ + "static/media/73.c102b6d2.png";